import { useSiteInfo } from '@contexts/SiteInfoContext';
import { useTranslation } from 'next-i18next';
import ServerPath from '../../configs/serverPath';

const EmptyMatch = () => {
    const { composePath } = useSiteInfo();
    const { t } = useTranslation();

    return (
        <div className="empty empty--no-event">
            <div className="empty__container">
                <div className="img">
                    <img src={composePath({ pathType: ServerPath.siteImage, pathName: 'empty.png' })} alt="" />
                </div>
                <div className="img">
                    <img
                        src={composePath({ pathType: ServerPath.siteImage, pathName: 'kv.svg' })}
                        alt=""
                    />
                </div>
                <div className="text">{t('lbl_NomatchesMsg1')}</div>
                <div className="text">{t('lbl_NomatchesMsg2')}</div>
            </div>
        </div>
    );
};

export default EmptyMatch;
